import {component} from '../form/Constant'
import {
    anySupplementaryOxygenOptions,
    bloodPressureColorData,
    bloodPressureDataRange,
    classNameTypes,
    confusionOptions,
    consciousnessOptions,
    consciousnessOptionsPatientPage,
    observationKeys,
    oxiColorData,
    pulseColorData,
    pulseDataRange,
    respirationColorData,
    respirationDataRange,
    spO2DataRange,
    tempColorData,
    temperatureDataRange,
} from '../observations/Constants'

import noPain from '../../assets/icons/1. no-pain.svg'
import unabletomove from '../../assets/icons/10. unable to move.svg'
import minimal from '../../assets/icons/2. minimal.svg'
import mild from '../../assets/icons/3. mild.svg'
import uncomfortable from '../../assets/icons/4. uncomfortable.svg'
import distracting from '../../assets/icons/5. distracting.svg'
import distressing from '../../assets/icons/6. distressing.svg'
import unmanageable from '../../assets/icons/7. unmanageable.svg'
import intense from '../../assets/icons/8. intense.svg'
import minimunbearableal from '../../assets/icons/9. unbearable.svg'
import {parameterValue} from '../parameter/ParameterConstants'

export const painScoreIconOptionsList = [
    {value: 1, icon: noPain},
    {value: 2, icon: minimal},
    {value: 3, icon: mild},
    {value: 4, icon: uncomfortable},
    {value: 5, icon: distracting},
    {value: 6, icon: distressing},
    {value: 7, icon: unmanageable},
    {value: 8, icon: intense},
    {value: 9, icon: minimunbearableal},
    {value: 10, icon: unabletomove},
]

export const patientObservationListForm = [
    {
        key: '',
        description: '',
        leftChildren: [
            {
                key: observationKeys.painScore,
                className: `grid justify-content-center col-12`,
                component: component.selectButton,
                options: painScoreIconOptionsList,
                icon: true,
            },
            {
                key: observationKeys.comment,
                className: `${classNameTypes.col12}`,
                component: component.inputTextArea,
                placeholder: 'Input your comment here...',
            },
        ],
        children: [
            {
                key: observationKeys.levelOfConsciousness,
                className: `md:${classNameTypes.col6} col-12 `,
                component: component.selectButton,
                options: consciousnessOptionsPatientPage,
                defaultValue: 'alert',
            },
            {
                key: observationKeys.confusion,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.selectButton,
                options: confusionOptions,
            },
            {
                key: observationKeys.heartRate,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.slider,
                min: 20,
                max: 220,
                step: '',
                shorten: parameterValue.beatsPerMinute,
                // dataRange: pulseDataRange,
                // colors: pulseColorData,
            },
            {
                key: observationKeys.respiration,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.slider,
                min: 1,
                max: 50,
                step: '',
                shorten: parameterValue.breathsPerMinute,
                // dataRange: respirationDataRange,
                // colors: respirationColorData,
            },
            {
                key: observationKeys.oxygen,
                className: classNameTypes.col12,
                component: component.slider,
                min: 50,
                max: 100,
                step: '',
                shorten: parameterValue.oxygen,
                // dataRange: spO2DataRange,
                // colors: oxiColorData,
            },
            {
                key: observationKeys.anySupplementaryOxygen,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.selectButton,
                options: anySupplementaryOxygenOptions,
                dataRange: [],
                // shorten: 'Litres/%',
            },
            {
                key: observationKeys.litres,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.slider,
                min: 0,
                max: 15,
                step: 1,
                // colors: tempColorData,
                // dataRange: temperatureDataRange,
            },
            {
                key: observationKeys.temperature,
                className: classNameTypes.col12,
                component: component.slider,
                min: 27,
                max: 43,
                step: 0.1,
                shorten: parameterValue.temperature,
                // colors: tempColorData,
                // dataRange: temperatureDataRange,
            },
            // {
            //     key: observationKeys.bloodPressureLimb,
            //     className: `md:${classNameTypes.col6} col-12`,
            //     component: component.selectButton,
            //     options: bloodPressureLimbOptions,
            // },
            // {
            //     key: observationKeys.bloodPressurePosition,
            //     className: `md:${classNameTypes.col6} col-12`,
            //     component: component.selectButton,
            //     options: bloodPressurePositionOptions,
            // },
            {
                key: observationKeys.systolic,
                className: `md:${classNameTypes.col6} col-12`,
                label: 'Blood Pressure Systolic',
                component: component.slider,
                min: 40,
                max: 250,
                step: '',
                shorten: parameterValue.systolic,
                // dataRange: bloodPressureDataRange,
                // colors: bloodPressureColorData,
            },
            {
                key: observationKeys.diastolic,
                className: `md:${classNameTypes.col6} col-12`,
                label: 'Blood Pressure Diastolic',
                component: component.slider,
                min: 30,
                max: 140,
                step: '',
                shorten: parameterValue.systolic,
                // dataRange: bloodPressureDataRange,
                // colors: bloodPressureColorData,
            },

            {
                key: observationKeys.bloodGlucoseLevel,
                className: classNameTypes.col12,
                component: component.slider,
                min: 0,
                max: 30,
                step: '',
                shorten: parameterValue.glucose,
            },
        ],
    },
]
export const latestObsList = [
    {
        key: observationKeys.painScore,
        className: `md:${classNameTypes.col12} col-12  `,
        component: component.selectButton,
        options: painScoreIconOptionsList,
        icon: true,
        color: `#FF9800`,
    },

    {
        key: observationKeys.levelOfConsciousness,
        className: `md:${classNameTypes.col6} col-12 `,
        component: component.selectButton,
        options: consciousnessOptions,
        defaultValue: 'alert',
        color: `#4CAF50`,
    },
    {
        key: observationKeys.confusion,
        className: `md:${classNameTypes.col6} col-12`,
        component: component.selectButton,
        options: confusionOptions,
        color: `#2196F3`,
    },
    {
        key: observationKeys.heartRate,
        className: classNameTypes.col6,
        component: component.slider,
        min: 20,
        max: 220,
        step: '',
        shorten: parameterValue.heartRate,
        dataRange: pulseDataRange,
        colors: pulseColorData,
        color: `#FF5722`,
    },
    {
        key: observationKeys.respiration,
        className: `md:${classNameTypes.col6} col-12`,
        component: component.slider,
        min: 1,
        max: 50,
        step: '',
        shorten: parameterValue.heartRate,
        dataRange: respirationDataRange,
        colors: respirationColorData,
        color: `#009688`,
    },
    {
        key: observationKeys.oxygen,
        className: classNameTypes.col12,
        component: component.slider,
        min: 50,
        max: 100,
        step: '',
        shorten: parameterValue.oxygen,
        dataRange: spO2DataRange,
        colors: oxiColorData,
        color: `#3F51B5`,
    },
    {
        key: observationKeys.anySupplementaryOxygen,
        className: `md:${classNameTypes.col6} col-12`,
        component: component.selectButton,
        options: anySupplementaryOxygenOptions,
        dataRange: [],
        // shorten: 'Litres/%',
        color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
    },
    {
        key: observationKeys.litres,
        className: `md:${classNameTypes.col6} col-12`,
        component: component.slider,
        min: 0,
        max: 15,
        step: 1,
        // colors: tempColorData,
        // dataRange: temperatureDataRange,
        color: `#FFC107`,
    },
    {
        key: observationKeys.temperature,
        className: classNameTypes.col12,
        component: component.slider,
        min: 27,
        max: 43,
        step: 0.1,
        shorten: parameterValue.temperature,
        colors: tempColorData,
        dataRange: temperatureDataRange,
        color: `#9C27B0`,
    },
    {
        key: observationKeys.systolic,
        className: `md:${classNameTypes.col6} col-12`,
        component: component.slider,
        min: 40,
        max: 250,
        step: '',
        shorten: parameterValue.systolic,
        dataRange: bloodPressureDataRange,
        colors: bloodPressureColorData,
        color: `#607D8B`,
    },
    {
        key: observationKeys.diastolic,
        className: `md:${classNameTypes.col6} col-12`,
        component: component.slider,
        min: 30,
        max: 140,
        step: '',
        shorten: parameterValue.systolic,
        dataRange: bloodPressureDataRange,
        colors: bloodPressureColorData,
        color: `#8BC34A`,
    },

    {
        key: observationKeys.bloodGlucoseLevel,
        className: classNameTypes.col12,
        component: component.slider,
        min: 0,
        max: 30,
        step: '',
        shorten: parameterValue.glucose,
        color: `#FFEB3B`,
    },
    // {
    //     key: observationKeys.comment,
    //     className: `${classNameTypes.col12} m-0 p-0 `,
    //     component: component.inputTextArea,
    //     placeholder: 'Input your comment here...',
    //     color: `${Math.floor(Math.random() * 16777215).toString(16)}`,
    // },
]

// export const symptomList = [
//     {
//         key: 'chestPain',
//         label: 'Chest pain',
//         data: 'Documents Folder',
//         icon: 'pi pi-fw pi-inbox',
//         children: [
//             {
//                 key: 'centralCrushingPain',
//                 label: 'Work',
//                 data: 'Central crushing pain',
//                 icon: 'pi pi-fw pi-cog',
//             },
//             {
//                 key: 'sharpStabbing',
//                 label: 'Sharp stabbing',
//                 data: 'Home Folder',
//                 icon: 'pi pi-fw pi-home',
//             },
//             {
//                 key: 'burningPain',
//                 label: 'Burning pain',
//                 data: 'Work Folder',
//                 icon: 'pi pi-fw pi-cog',
//             },
//             {
//                 key: 'cantDescribeButItHurts',
//                 label: "Can't describe but it hurts",
//                 data: 'Home Folder',
//                 icon: 'pi pi-fw pi-home',
//             },
//             {
//                 key: 'minorPain',
//                 label: 'Minor pain',
//                 data: 'Work Folder',
//                 icon: 'pi pi-fw pi-cog',
//             },
//         ],
//     },
//     {
//         key: 'palpitations',
//         label: 'Palpitations',
//         data: 'Events Folder',
//         icon: 'pi pi-fw pi-calendar',
//     },
//     {
//         key: 'feelingSick',
//         label: 'Feeling sick (nauseous)',
//         data: 'Movies Folder',
//         icon: 'pi pi-fw pi-star-fill',
//     },
//     {
//         key: 'heartburn',
//         label: 'Heartburn',
//         data: 'Events Folder',
//         icon: 'pi pi-fw pi-calendar',
//     },
//     {
//         key: 'sweaty',
//         label: 'Sweaty',
//         data: 'Movies Folder',
//         icon: 'pi pi-fw pi-star-fill',
//     },
//     {
//         key: 'clammy',
//         label: 'Clammy',
//         data: 'Events Folder',
//         icon: 'pi pi-fw pi-calendar',
//     },
// ]

export const respiratoryChildrenList = [
    {
        key: 'shortnessOfBreath',
        label: 'Shortness of breath',
    },
    {
        key: 'dryCough',
        label: 'Dry cough',
    },
    {
        key: 'fever',
        label: 'Fever',
    },
    {
        key: 'wheeze',
        label: 'Wheeze',
    },
    {
        key: 'chestPain',
        label: 'Chest pain',
    },
]

export const frailtyChildrenList = [
    {
        key: 'memoryProblems',
        label: 'Memory Problems',
    },
    {
        key: 'falls',
        label: 'Falls',
    },
    {
        key: 'confusion',
        label: 'Confusion',
    },
    {
        key: 'fatigue',
        label: 'Fatigue',
    },
    {
        key: 'immobility',
        label: 'Immobility',
    },
    {
        key: 'bowel/UrinaryIncontinence',
        label: 'Bowel/urinary incontinence',
    },
    {
        key: 'constipation',
        label: 'Constipation',
    },
]

export const heartFailureChildrenList = [
    {
        key: 'chestPain',
        label: 'Chest pain',
    },
    {
        key: 'shortnessOfBreath',
        label: 'Shortness of breath',
    },
    {
        key: 'confusion',
        label: 'Confusion',
    },
    {
        key: 'palpitations',
        label: 'Palpitations',
    },
    {
        key: 'Nausea/Vomiting',
        label: 'Nausea/Vomiting',
    },
    {
        key: 'fainting',
        label: 'Fainting',
    },
    {
        key: 'SwollenFeetOrAnkles',
        label: 'Swollen feet or ankles',
    },
]
export const diabetesChildrenList = [
    {
        key: 'frequentUrination',
        label: 'Frequent urination',
    },
    {
        key: 'feelingThirsty',
        label: 'Feeling thirsty',
    },
    {
        key: 'fatigue',
        label: 'Fatigue',
    },
    {
        key: 'slowHealing',
        label: 'Slow healing',
    },
    {
        label: 'Blurred vision',
        key: 'blurredVision',
    },
]
export const colorectalChildrenList = [
    {
        key: 'vomiting',
        label: 'Vomiting',
    },
    {
        key: 'comitingWithBlood',
        label: 'Vomiting with blood',
    },
    {
        key: 'diarrhoea',
        label: 'Diarrhoea',
    },
    {
        key: 'diarrhoeaWithBlood',
        label: 'Diarrhoea with blood',
    },
    {
        key: 'constipation',
        label: 'Constipation',
    },
    {
        key: 'fainting',
        label: 'Fainting',
    },
    {
        key: 'stomachPain',
        label: 'Stomach pain',
    },
]

export const symptomOptionsList = [
    {
        key: 'respiratory',
        label: 'Respiratory',
        children: [
            {
                key: 'COVID19',
                label: 'COVID19',
                children: respiratoryChildrenList,
            },
            {
                key: 'COPD',
                label: 'COPD',
                children: respiratoryChildrenList,
            },
            {
                key: 'acuteRespiratoryInfections',
                label: 'Acute respiratory infections',
                children: respiratoryChildrenList,
            },
            {
                key: 'asthma',
                label: 'Asthma',
                children: respiratoryChildrenList,
            },
        ],
    },
    {
        key: 'geriatrics',
        label: 'Geriatrics',
        children: [
            {
                key: 'frailty',
                label: 'Frailty',
                children: frailtyChildrenList,
            },
        ],
    },
    {
        key: 'cardiology',
        label: 'Cardiology',
        children: [
            {
                key: 'iHD',
                label: 'IHD',
                children: heartFailureChildrenList,
            },
            {
                key: 'heartFailure',
                label: 'Heart failure',
                children: heartFailureChildrenList,
            },
        ],
    },
    {
        key: 'endo',
        label: 'Endo',
        children: [
            {
                key: 'Diabetes',
                label: 'Diabetes',
                children: diabetesChildrenList,
            },
        ],
    },
    {
        key: 'generalSurgery',
        label: 'General Surgery',
        children: [
            {
                key: 'colorectal',
                label: 'Colorectal',
                children: colorectalChildrenList,
            },
            {
                key: 'upperGI',
                label: 'Upper GI',
                children: colorectalChildrenList,
            },
        ],
    },
]

export const treeOption = optionList => {
    if (!optionList && !Array.isArray(optionList)) {
        return []
    }
    let holderOptionList = []

    for (let i = 0; optionList.length > i; i++) {
        let parentItem = {
            ...optionList[i],
            key: `${i}`,
        }

        if (parentItem.children && Array.isArray(parentItem.children)) {
            let holderParentArr = []
            for (let j = 0; parentItem.children.length > j; j++) {
                let childrenItem = {
                    ...parentItem.children[j],
                    key: `${parentItem.key}-${j}`,
                }

                if (
                    childrenItem.children &&
                    Array.isArray(childrenItem.children)
                ) {
                    let holderChildrenArr = []
                    for (let g = 0; childrenItem.children.length > g; g++) {
                        let objChildrenList = {
                            ...childrenItem.children[g],
                            key: `${childrenItem.key}-${g}`,
                        }

                        holderChildrenArr.push(objChildrenList)
                    }
                    childrenItem.children = holderChildrenArr
                }

                holderParentArr.push(childrenItem)
            }
            parentItem.children = holderParentArr
        }

        holderOptionList.push(parentItem)
    }
    return holderOptionList
}

export const compareTreeOption = optionList => {
    if (!optionList && !Array.isArray(optionList)) {
        return []
    }

    let holderOptionList = []

    for (let i = 0; optionList.length > i; i++) {
        let parentItem = {
            key: optionList[i].key,
            label: optionList[i].label,
        }
        if (optionList[i].children && Array.isArray(optionList[i].children)) {
            let parentOptionList = optionList[i].children
            for (let j = 0; parentOptionList.length > j; j++) {
                let childrenItem = {
                    key: parentOptionList[j].key,
                    label: parentOptionList[j].label,
                }
                if (
                    parentOptionList[j].children &&
                    Array.isArray(parentOptionList[j].children)
                ) {
                    let childrenOptionList = parentOptionList[j].children
                    for (let g = 0; childrenOptionList.length > g; g++) {
                        let objItem = {
                            key: childrenOptionList[g].key,
                            label: childrenOptionList[g].label,
                        }
                        holderOptionList.push(objItem)
                    }
                }
                holderOptionList.push(childrenItem)
            }
        }
        holderOptionList.push(parentItem)
    }
    return holderOptionList
}
